import { ApolloError } from '@apollo/client';
import { ProgressRodRequestWeldErrorCode, ProgressRodRequestWeldErrors } from '@bechtel/types';

export type ProgressRodRequestErrorType = ProgressRodRequestWeldErrorCode | ApolloError;

export interface ProgressRodRequestErrorProps {
  errorRodRequests: ProgressRodRequestWeldErrors[] | null;
  error: ProgressRodRequestErrorType | null;
  onClose: () => void;
}
